exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".addbanners[data-v-1d52abce]{padding-top:20px;padding-right:20px}.avatar-uploader .el-upload[data-v-1d52abce]{border-radius:6px;cursor:pointer;position:relative;overflow:hidden}.avatar-uploader .el-upload[data-v-1d52abce]:hover{border-color:#409eff}.avatar-uploader-icon[data-v-1d52abce]{font-size:28px;color:#8c939d;width:178px;height:178px;line-height:178px;text-align:center;border:1px dashed #d9d9d9}.avatar[data-v-1d52abce]{width:178px;height:178px;display:block}\n", ""]);

// exports
